import { observer } from "mobx-react"
import React, { useRef, useEffect, useState } from "react"
import { DataLayerFn } from "../../../Configs/API"
import CommonStore from "../../../Configs/Store/common"
import FormStore from "../../../Configs/Store/forms"
import AppStore from "../../../Configs/Store/index"
import CircleIcon from "../../Common/CircleIcon"
import CloseButton from "../../Common/CloseButton"
import DyCard from "../../Common/DyCard"
import FlipCard from "../../Common/FlipCard"
import GenericCarousal from "../../Common/GenericCarousal"
import GenericModal from "../../Common/GenericModal"
import "./MythBuster.less"
import MythBusterData from "../../../Configs/JSON/MythBusterData.json"

const MythBuster = observer(({ calculatorRef }) => {
  const [showEffect, setShowEffect] = useState(false)
  const JSON = MythBusterData
  const staticData = JSON.sectionConfig
  const data = JSON.data
  const mythBusterMainRef = useRef(null)

  useEffect(() => {
    if (AppStore.frame_footer) setShowEffect(true)

    if (!AppStore.frame_footer && showEffect === true) {
      let mythDOMClasses = mythBusterMainRef.current.classList
      mythDOMClasses.add("MythBusterHide")
      setShowEffect(false)
      setTimeout(() => {
        mythDOMClasses.remove("MythBusterHide")
      }, 150)
    }
  }, [AppStore.frame_footer])

  const executeScroll = (ref) => ref.current.scrollIntoView({ behavior: "smooth" })

  const closeAllBenMobModal = () => {
    CommonStore.setmythBusterModal(false)
    // window. ViewAllBenefits_PopupClose
    DataLayerFn("MythBusters_PopupClose||Calculator-Landing page|Myth Busters", FormStore, "", "", "", "")
  }

  const handleModalShow = () => {
    DataLayerFn("MythBusters_Selected||Calculator-Landing page|Myth Busters", FormStore, "", "", "", "")

    CommonStore.setmythBusterModal(true)

    setTimeout(() => {
      DataLayerFn("MythBusters_PopupOpen||Calculator-Landing page|Myth Busters", FormStore, "", "", "", "")
      document.querySelector(".mythBusterCarousal > img:nth-child(3)")?.addEventListener("click", () => DataLayerFn("MythBusters_Next||Calculator-Landing page|MythBuster", FormStore, "", "", "", ""))
      document
        .querySelector(".mythBusterCarousal > img:nth-child(1)")
        ?.addEventListener("click", () => DataLayerFn("MythBusters_Previous||Calculator-Landing page|MythBuster", FormStore, "", "", "", ""))
    }, 100)
  }

  const onClickOk = async () => {
    DataLayerFn("MythBusters_CalculateReturns||Calculator-Landing page|Myth Busters", FormStore, "", "", "", "")
    CommonStore.setmythBusterModal(false)
    await executeScroll(calculatorRef)
    setTimeout(() => {
      document.querySelector(".CalculatorCard .calculateFormButton").click()
    }, 1000)
  }

  return (
    <section ref={mythBusterMainRef} className={`MythBusterRoot ${AppStore.frame_footer ? "MythBusterShow" : ""}`}>
      <div className="Button" onClick={handleModalShow}>
        <CircleIcon
          iconUrl={AppStore.device === 1 ? staticData.iconUrl : staticData.iconMob}
          imgheight={AppStore.device === 1 ? "30px" : "22px"}
          imgwidth={AppStore.device === 1 ? "25.79px" : "22px"}
          imgalt={"Myth Busters"}
        />
        <div className="text">{staticData.buttonName}</div>
      </div>

      <GenericModal
        visibleState={CommonStore.mythBusterModal}
        updateVisibility={closeAllBenMobModal}
        closeIcon={
          AppStore.device === 0 ? (
            <CircleIcon iconUrl={`assets/common/Path15589.svg`} iconStyle="closeIconModalMob" onClick={closeAllBenMobModal} imgalt={"Close"} imgheight={"26px"} imgwidth={"26px"} />
          ) : (
            <div className="PCModalTextCrossWrapper">
              <CloseButton className="closeIconModalPC" onClick={closeAllBenMobModal} />
            </div>
          )
        }
        showButton={AppStore.device === 1 ? true : false}
        buttonText={staticData.ModlabuttonName}
        buttononClick={onClickOk}
        rootClassAntCustom={"MythBustermodal"}
        forceRender={true}
        component={
          <>
            <div className="head">
              <div className="title1">{staticData[`title${AppStore.device}`]}</div>
              <div className="title2">{staticData.title}</div>
            </div>

            {AppStore.device === 1 ? (
              <div className="FlipCardsWrap">
                {data.map((x, i) => (
                  <FlipCard
                    id={i}
                    key={"MythBuster_" + new Date().getTime() + "_" + i}
                    front={<DyCard title={x.title} icon2={x.iconId} content={staticData.Ffooter} className="front" imgwidth="149px" imgheight="149px" imgalt={x.iconAlt} />}
                    back={<DyCard title={x.title} icon3={x.iconId} content={x.content} className="back" imgwidth="117px" imgheight="117px" imgalt={x.iconAlt} />}
                  />
                ))}
              </div>
            ) : (
              <GenericCarousal
                stateObserve={"WhatIsMythId"}
                stateUpdate={"setWhatIsMythId"}
                rootStyle={"mythBusterCarousal"}
                data={data}
                autoplay={false}
                arrows={true}
                ArrowComp={<CircleIcon iconUrl="myth/arrowcarousal" imgalt={"Change Slide"} imgwidth={"34px"} imgheight={"34px"} />}
                dots={true}
                dotPosition="top"
                effect={"fade"}
                imgwidth0="207px"
                imgheight0="207px"
              />
            )}
          </>
        }
      />
    </section>
  )
})

export default MythBuster
